import * as React from 'react';

export class HomePage extends React.PureComponent {
  public render() {
    return (
      <div className="home-page">
        <div className="home-page__bg" />

        <div className="home-page__buttons">
          <button>Bestel</button>
          <img className="home-page__logo" src={require('../../../assets/Logo.png')} />
          <button>Reserveer</button>
        </div>
      </div>
    );
  }
}
